import { Button } from '@mui/material';
import { AppConfig } from 'AppConfig';
import { fetchData, waitForTenantSwitch } from 'features/user/userActions';
import * as UserTypes from 'features/user/userTypes';
import { useEffect, useRef, useState } from 'react';
import { Beforeunload } from 'react-beforeunload';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import routePaths from 'routes/routePaths';
import * as AppActionTypes from 'store/actions/appstate';
import { store } from 'store/store';
import { hasPermission } from 'utils/common';
import LocalStore from 'utils/LocalStore';
import MasterNav from './masterNav';

const Master = (props) => {
  const [state, setState] = useState({
    onInitialLoad: true,
    refreshKey: 0,
    currentMDItem: null
  });

  const navigate = useNavigate();
  const attemptedSwitchRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    store.dispatch({
      type: UserTypes.APP_SWITCHED,
      payload: AppConfig.HEADER_MENU_TYPE.STANDARD
    });

    navigate(`${routePaths.master}/${AppConfig.MASTER_DATA_SUB_URL.MASTER_TABLE}`, { replace: true });

    // The header owns tenant switching; once it has minted a MASTER_DATA token
    // this page must not issue a second, competing switch.
    if (props.currentApp === AppConfig.APP_CODE_MASTER_DATA) {
      attemptedSwitchRef.current = props.currentTenant;
      return;
    }

    if (!props.currentTenant) {
      return;
    }

    if (attemptedSwitchRef.current === props.currentTenant) {
      return;
    }
    attemptedSwitchRef.current = props.currentTenant;

    // Wait out a switch already in flight (e.g. from the header) and re-read the
    // store so this doesn't dispatch a competing switch for a stale tenant.
    (async () => {
      await waitForTenantSwitch();
      if (cancelled) return;

      const { currentTenantCd: latestTenant, currentApp: latestApp } = store.getState().user;
      attemptedSwitchRef.current = latestTenant;

      if (!latestTenant || latestApp === AppConfig.APP_CODE_MASTER_DATA) {
        return;
      }

      store.dispatch(fetchData(latestTenant, AppConfig.APP_CODE_MASTER_DATA, { explicitTenant: false }));
    })();

    return () => {
      cancelled = true;
    };
  }, [props.currentTenant, props.currentApp]);

  const onMarkAsCompleted = async () => {
    try {
      const response = await fetch(
        AppConfig.API_BASE_URL + `mail/sendMDCompleteMail`,
        {
          method: 'get',
          headers: {
            Authorization: 'Bearer ' + LocalStore.getAccessToken()
          }
        }
      );
      if (!response.ok) {
        throw new Error('Network Error');
      }
      store.dispatch({
        type: AppActionTypes.APP_REST_CALL_SUCESSED,
        payload: 'Master data notification email send successfully'
      });
    } catch (error) {
      store.dispatch({
        type: AppActionTypes.APPSTATE_SET_APP_ERROR,
        payload: 'Failed to send master data notification email: Unknown Error'
      });
    }
  };

  const renderMasterHead = () => {
    return (
      <div key={state.refreshKey + props.lastReturnTime}>
        <div className="master-office">
          <div className="master-office__top">
            <div className="row pb-4">
              <div className="col-4"></div>
              <div className="col-8 text-right">
                {state.currentMDItem ? (
                  <Button
                    variant="contained"
                    disableElevation
                    style={{
                      backgroundColor: '#377DC7',
                      height: '36px',
                      marginTop: '5px',
                      color: 'white',
                      marginLeft: '5px',
                      marginRight: '5px',
                      textTransform: 'none'
                    }}
                    onClick={() => {
                      setState({ ...state, currentMDItem: null });
                      navigate(-1);
                    }}>
                    Back
                  </Button>
                ) : null}
                {hasPermission(
                  AppConfig.PERMISSION.MD_DI,
                  props.permissions
                ) ? (
                  <Button
                    variant="contained"
                    disableElevation
                    style={{
                      backgroundColor: '#377DC7',
                      height: '36px',
                      marginTop: '5px',
                      color: 'white',
                      marginLeft: '5px',
                      marginRight: '5px',
                      textTransform: 'none'
                    }}
                    disabled={window.location.pathname === `${routePaths.master}/${AppConfig.MASTER_DATA_SUB_URL.DI_JOBS}`}
                    onClick={() => {
                      if (window.location.pathname === `${routePaths.master}/${AppConfig.MASTER_DATA_SUB_URL.DI_JOBS}`) return;
                      setState({ ...state, currentMDItem: 'dijob' });
                      navigate(
                        `${routePaths.master}/${AppConfig.MASTER_DATA_SUB_URL.DI_JOBS}`
                      );
                    }}>
                    DI Jobs
                  </Button>
                ) : null}
                {hasPermission(
                  AppConfig.PERMISSION.MD_VAULT,
                  props.permissions
                ) ? (
                  <Button
                    variant="contained"
                    disableElevation
                    style={{
                      backgroundColor: '#377DC7',
                      height: '36px',
                      marginTop: '5px',
                      color: 'white',
                      marginLeft: '5px',
                      marginRight: '5px',
                      textTransform: 'none'
                    }}
                    onClick={() => {
                      onMarkAsCompleted();
                    }}>
                    Mark as Completed
                  </Button>
                ) : null}
              </div>
            </div>
          </div>
          <section>
            {state.currentMDItem !== 'dijob' &&
              <MasterNav {...props} />
            }
          </section>
        </div>
      </div>
    );
  };

  return (
    <>
      <Beforeunload
        onBeforeunload={(event) => {
          if (
            window.location.pathname &&
            window.location.pathname === routePaths.master
          ) {
            if (state.onInitialLoad === true) {
              setState({ ...state, onInitialLoad: false });
            } else {
              setState({
                ...state,
                refreshKey: state.refreshKey + 1
              });
            }
          }
        }}></Beforeunload>
      {renderMasterHead()}
    </>
  );
};

const mapStateToPropsSelector = createStructuredSelector({
  currentTenant: (state) => state.user.currentTenantCd,
  currentApp: (state) => state.user.currentApp,
  permissions: (state) => state.user.permissions,
  planSponsor: (state) => state.masterTable.planSponsor,
  planSponsorLoading: (state) => state.masterTable.planSponsorLoading
});

export default connect(mapStateToPropsSelector)(Master);
